// Custom functionality and components.
/* global ga: true */

import $ from 'jquery';
import Cookies from 'js-cookie';
import Navigo from 'navigo';
import 'magnific-popup';
import './cf-ajax-form/main';
import './cf-ajax-handler/main';
import './cf-dynamic-menu/main';
import './dynamic-menu';
import './resources-modal';

global.Cookies = Cookies;
global.Navigo = Navigo;

const cfProjectHero = window.cfProjectHero;

$.ajaxForm.setDefaults({ ajaxUrl: cfProjectHero.ajaxUrl });
$.setCFAJAXHandlerDefaults({ ajaxUrl: cfProjectHero.ajaxUrl });

// Initialize the AJAX Form.
$('.js-cf-ajax-form').ajaxForm();

$(window).on('load cf_analytics_track_page', () => {
  const hash = window.location.hash;
  const section = $('.js-section:not(.d-none)').first();
  let pathname = window.location.pathname;
  let cookie = '';
  let cookieData = null;
  let uniqueQuestInfo = '';
  let pageTitle = '';
  let pageParams = {};
  let sectionTitle = '';
  let sectionSubtitle = '';

  if (typeof hash !== 'undefined') {
    pathname += hash;
  }
  if (typeof ga !== 'undefined') {
    if (typeof section !== 'undefined') {
      sectionTitle = section.find('.js-section-title').first().data('sectionTitle');
      if (typeof sectionTitle !== 'undefined') {
        pageTitle = sectionTitle;
        sectionSubtitle = section.find('.js-section-subtitle').first().data('sectionSubtitle');
        if (typeof sectionSubtitle !== 'undefined') {
          pageTitle = `${pageTitle} - ${sectionSubtitle}`;
        }
      }
    }

    pageParams = {
      page: pathname,
    };
    if (pageTitle.length > 0) {
      pageParams.title = pageTitle;
    }
    ga('set', pageParams);
    cookie = Cookies.get('cf_quest_tracking');
    if (cookie) {
      cookieData = $.parseJSON(cookie);
      if (Object.keys(cookieData).length > 3) {
        uniqueQuestInfo = `quest-${cookieData.quest_id}|educator-${cookieData.educator_id}|${cookieData.unique_url}`;
        ga('set', 'contentGroup1', uniqueQuestInfo);
      }
    }
    ga('send', 'pageview');
  }
});



// WEBPACK FOOTER //
// ./assets/js/main.js